import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { Result } from '@/main/models/common/resultResponse';
import { SystemGuideSearchRequest, SystemGuidRequest } from '@/main/models/request/systemGuideRequest';
import { SystemGuideDetailResponse, SystemGuideSearchGridResponse } from '@/main/models/response/systemGuideResponse';
import { AxiosResponse } from 'axios';

export abstract class ISystemGuideApi {
  abstract save(
    request: SystemGuidRequest,
    file: File | null
  ): Promise<AxiosResponse<Result<string>>>;

  abstract getDetails(
    guidSystemGuide: string
  ): Promise<AxiosResponse<Result<SystemGuideDetailResponse>>>;

  abstract getSearchGrid(
    request: SystemGuideSearchRequest
  ): Promise<AxiosResponse<PaginationResponse<SystemGuideSearchGridResponse>>>;

  abstract downloadImportFile(
    guidFileImport: string
  ): Promise<AxiosResponse<Result<string>>>;
}
